import {
  isMessageWithCreationTaskId,
  isMessageWithImageGenTask,
  Message,
  MessageSkill,
  TaskState,
} from 'src/types';
import { MessageWithTaskProgress } from '../MessageWithTaskProgress';
import styles from './MessageProgress.module.scss';
import { DEFAULT_THINKING_TEXT } from 'src/constants';

interface MessageProgressProps {
  customComponent?: React.ReactNode;
  message: Message;
  taskId?: string;
  taskState?: TaskState;
  messageSkill: MessageSkill | null;
}

export const MessageProgress = ({
  customComponent,
  message,
  taskId,
  taskState,
  messageSkill,
}: MessageProgressProps) => {
  if (customComponent) {
    return <>{customComponent}</>;
  }

  const { payload } = message;

  if (!payload) {
    return <p className={styles.text}>{DEFAULT_THINKING_TEXT}</p>;
  }

  if (
    !isMessageWithCreationTaskId(message) &&
    !isMessageWithImageGenTask(message)
  ) {
    return null;
  }

  return (
    <MessageWithTaskProgress
      message={message}
      taskId={taskId}
      taskState={taskState}
      messageSkill={messageSkill}
    />
  );
};
